import httpClient from "http-client/http-client";

// BFF community-portal discount codes routes (contract §4.7). The vendor comes
// from the portal session in the BFF, never from the client.
const BASE = "v1/community-portal/discount-codes";

/** Switch state, vendor policy and community flags (D-1, D-2, D-3). */
export async function getDiscountCodesConfig() {
  const { data, errors } = await httpClient.get({ url: `${BASE}/config` });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/** `{ current_page, page_size, search?, status?, event_id?, community_id? }` */
export async function fetchDiscountCodes(body) {
  const { data, errors } = await httpClient.post({
    url: `${BASE}/fetch`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/** 30-day tiles, optionally for one community. */
export async function getDiscountCodesSummary({ community_id } = {}) {
  const { data, errors } = await httpClient.get({
    url: `${BASE}/summary`,
    params: community_id ? { community_id } : {},
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function createDiscountCode(body) {
  const { data, errors } = await httpClient.post({ url: BASE, body });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function getDiscountCode(codeId, { run_id } = {}) {
  const { data, errors } = await httpClient.get({
    url: `${BASE}/${encodeURIComponent(codeId)}`,
    params: run_id ? { run_id } : {},
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/** Partial body: omitted fields stay unchanged. */
export async function updateDiscountCode(codeId, body) {
  const { data, errors } = await httpClient.patch({
    url: `${BASE}/${encodeURIComponent(codeId)}`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/**
 * `action`: PAUSE | RESUME | END | RUN_AGAIN. RUN_AGAIN needs
 * `run: { expires_at, starts_at? }`; other actions send no `run`.
 */
export async function runDiscountCodeAction(codeId, action, run) {
  const { data, errors } = await httpClient.post({
    url: `${BASE}/${encodeURIComponent(codeId)}/action`,
    body: run ? { action, run } : { action },
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/** `{ current_page, page_size, run_id? }` */
export async function fetchDiscountCodeRedemptions(codeId, body) {
  const { data, errors } = await httpClient.post({
    url: `${BASE}/${encodeURIComponent(codeId)}/redemptions/fetch`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/** `{ current_page, page_size }` (pagination counts change events). */
export async function fetchDiscountCodeHistory(codeId, body) {
  const { data, errors } = await httpClient.post({
    url: `${BASE}/${encodeURIComponent(codeId)}/history/fetch`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function getDiscountCodesPolicy() {
  const { data, errors } = await httpClient.get({ url: `${BASE}/policy` });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/** `{ max_total_percent }` */
export async function updateDiscountCodesPolicy(body) {
  const { data, errors } = await httpClient.put({
    url: `${BASE}/policy`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}
